import request from '@/utils/request'

// 获取网站配置
export function getSiteConfig() {
  return request({
    url: '/api/common/config',
    method: 'get'
  })
}

// 健康检查
export function healthCheck() {
  return request({
    url: '/api/common/health',
    method: 'get'
  })
}

// 获取服务器时间
export function getServerTime() {
  return request({
    url: '/api/common/server-time',
    method: 'get'
  })
}